module.exports = __webpack_public_path__ + "static/media/carosel1.5459f992.png";